import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    patients: {},
    allCases: [],
    incompleteForms: [],
    mostRecentCase: null,
    selectedIncompleteForm: null,
    appointments: {}
};

const portalSlice = createSlice({
    name: 'portal',
    initialState,
    reducers: {
        reset: (state) => {
            return { ...initialState };
        },
        setPatientInfo: (state, action) => {
            const { id, ...patientInfo } = action.payload;
            state.patients[id] = { ...state.patients[id], ...patientInfo };
        },
        setAllCases: (state, action) => {
            state.allCases = action.payload;
        },
        setIncompleteForms: (state, action) => {
            state.incompleteForms = action.payload;
        },
        setSelectedIncompleteForm: (state, action) => {
            state.selectedIncompleteForm = action.payload;
        },
        updatePortalData: (state, action) => {
            const { patientData } = action.payload;
            if (Array.isArray(patientData) && patientData.length > 0) {
                let allCases = [];
                let incompleteForms = [];
                let mostRecentSubmittedCase = null;

                patientData.forEach(patient => {
                    state.patients[patient.id] = {
                        id: patient.id,
                        first_name: patient.first_name,
                        last_name: patient.last_name,
                        full_name: patient.full_name,
                        date_of_birth: patient.date_of_birth,
                        gender: patient.gender,
                        contact: {
                            email: patient.contact?.email || '',
                            phone: patient.contact?.phone || '',
                        },
                        state: patient.state,
                        insurance: {
                            payerName: patient.insurance?.payerName || '',
                        },
                    };

                    const appts = Array.isArray(patient.appointment)
                        ? patient.appointment.map(a => ({
                            id: a.id,
                            appointment_time: a.appointment_time,
                            status: a.status,
                            video_link: a.video_link,
                        }))
                        : [];
                    state.appointments[patient.id] = appts;

                    if (Array.isArray(patient.cases)) {
                        patient.cases.forEach(caseItem => {
                            if (
                                (caseItem.intakes && caseItem.intakes[0] && caseItem.intakes[0].submitted_at) ||
                                (caseItem.returning_intakes && caseItem.returning_intakes[0] && caseItem.returning_intakes[0].submitted_at)
                            ) {
                                const submittedCase = {
                                    id: caseItem.id,
                                    patientID: patient.id,
                                    patient_name: patient.full_name,
                                    created_at: caseItem.created_at,
                                    submitted_at:
                                        caseItem.intakes && caseItem.intakes[0]
                                            ? caseItem.intakes[0].submitted_at
                                            : caseItem.returning_intakes[0].submitted_at,
                                    is_closed: caseItem.is_closed,
                                    np_is_closed: caseItem.np_is_closed,
                                    patient_reported_concern:
                                        caseItem.intakes && caseItem.intakes[0]
                                            ? caseItem.intakes[0].patient_reported_concern
                                            : '',
                                    assessment: caseItem.assessment,
                                    np_assessment: caseItem.np_assessment,
                                    recommended_follow_up: caseItem.recommended_follow_up,
                                    plan: caseItem.plan,
                                    np_plan: caseItem.np_plan,
                                    prescribed_medications: caseItem.prescribed_medications,
                                    is_returning: !!(caseItem.returning_intakes && caseItem.returning_intakes[0]),
                                    is_insurance: patient.fields.Payer === "Insurance",
                                    addendum: caseItem.addendum,
                                    is_npa: patient.fields.npa === "yes",
                                    md_submitted_by_name: caseItem.md_submitted_by_name,
                                    np_submitted_by_name: caseItem.np_submitted_by_name
                                };

                                allCases.push(submittedCase);

                                if (
                                    !mostRecentSubmittedCase ||
                                    new Date(submittedCase.submitted_at) > new Date(mostRecentSubmittedCase.submitted_at)
                                ) {
                                    mostRecentSubmittedCase = submittedCase;
                                }
                            } else {
                                incompleteForms.push({
                                    caseID: caseItem.id,
                                    patientID: patient.id,
                                    patientName: patient.full_name,
                                    created_at: caseItem.created_at,
                                    fullPatientData: patient,
                                    fullCaseData: caseItem
                                });
                            }
                        });
                    } else {
                        console.warn(`Patient ${patient.id} has no cases or cases is not an array`);
                    }
                });

                state.allCases = allCases.sort((a, b) => {
                    return new Date(b.submitted_at) - new Date(a.submitted_at);
                });

                state.incompleteForms = incompleteForms;
                state.mostRecentCase = mostRecentSubmittedCase;

            } else {
                console.warn("patientData is not an array or is empty", patientData);
            }
        },
    },
});

export const {
    reset,
    setPatientInfo,
    setAllCases,
    setIncompleteForms,
    updatePortalData,
    setSelectedIncompleteForm,
} = portalSlice.actions;

export default portalSlice.reducer;
